import { bookmarkOutline, calendarOutline, personOutline } from "ionicons/icons";
import { useSelector } from "react-redux";
import { selectDocument } from "../../../store/documentShow/selectors/selectDocument";
import { IonIcon, IonItem, IonLabel, IonNote, IonText, isPlatform } from "@ionic/react";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
export const SectionDescriptionDetail: React.FC = () => {
  const document = useSelector(selectDocument);

  return (
    <>
      <IonItem lines="none" color="transparent" class="ion-hide-md-down">
        <IonLabel>
          <h1 style={{ fontWeight: 500 }}>{document.title}</h1>
          <h6>
            <IonIcon icon={personOutline} />
            <IonText class="ion-padding-start">{`Subido por ${document.author?.name}`}</IonText>
          </h6>
          <h6>
            <IonIcon icon={calendarOutline} />
            <IonText class="ion-padding-start">{`Creado el ${document.createdAt}`}</IonText>

            <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
            <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
          </h6>
        </IonLabel>
        {isPlatform("desktop") && (
          <IonNote slot="end">
            <DocumentStatusTag document={document} />
          </IonNote>
        )}
      </IonItem>
    </>
  );
};
